function capitalize(str) {
  return str.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
}

const appName = process.env.MIX_APP_NAME;

// prettier-ignore
const message = {
  form: {
    enter: "Masukkan {attribute}",
    inputValidPhone: "Mohon dimasukkan nomor telepon dan kode negara yang sesuai",
    select: "Pilih {attribute}",
    fillRequired: "Mohon diisi data yang diperlukan untuk lanjut",
    uploadFileInstr: "Klik untuk mencari atau letakkan file disini",
    fileReadyToSend: "File siap untuk diunggah",
    selectSuggestion: "Pilih dari daftar",
    clickInputContactInfo: "Klik untuk mengisi informasi kontak",
  },
  alert: {
    validationFailed: "Validasi gagal",
    inputFieldWarning: "Mohon disertakan informasi akun yang benar di dalam tiap kolom masukan",
    accept: "OK, saya mengerti",
  },
  day: {
    sunday: "Minggu",
    monday: "Senin",
    tuesday: "Selasa",
    wednesday: "Rabu",
    thursday: "Kamis",
    friday: "Jumat",
    saturday: "Sabtu",
  },
  validation: {
    messages: {
      _default: "Nilai {0} tidak sah",
      after: "Data {0} harus sebelum {1}",
      alpha: "Data {0} hanya boleh mengandung karakter alfabet",
      alpha_dash: "Data {0} boleh mengandung karakter alfanumerik, tanda hubung, dan garis bawah",
      alpha_num: "Data {0} hanya boleh mengandung karakter alfanumerik",
      alpha_spaces: "Data {0} hanya boleh berisi karakter alfabet serta spasi",
      before: "Data {0} harus setelah {1}",
      between: "Data {0} harus di antara {1} dan {2}",
      confirmed: "Data {0} tidak cocok dengan {1}",
      credit_card: "Data {0} tidak sah",
      date_between: "Data {0} harus di antara {1} dan {2}",
      date_format: "Data {0} harus dalam format {1}",
      decimal: "Data {0} harus berupa angka dan boleh mengandung {1} titik desimal",
      digits: "Data {0} harus berupa {1} digit angka",
      dimensions: "Data {0} harus berdimensi lebar {1} pixel dan tinggi {2} pixel",
      email: "Data {0} harus berupa alamat surel yang benar",
      excluded: "Data {0} harus berupa nilai yang sah",
      ext: "Data {0} harus berupa berkas yang benar",
      image: "Data {0} harus berupa gambar",
      included: "Data {0} harus berupa nilai yang sah",
      integer: "Data {0} harus berupa bilangan bulat",
      ip: "Data {0} harus berupa alamat ip yang sah",
      ip_or_fqdn: "Data {0} harus berupa alamat ip atau FQDN yang sah",
      length: "Panjang {0} harus di antara {1} dan {2}",
      max: "Data {0} tidak boleh lebih dari {1} karakter",
      max_value: "Nilai {0} tidak boleh lebih dari {1}",
      mimes: "Tipe berkas {0} harus benar",
      min: "Data {0} minimal mengandung {1} karakter",
      min_value: "Data Nilai {0} tidak boleh kurang dari {1}",
      numeric: "Data {0} harus berupa angka",
      regex: "Format {0} salah",
      required: "Data {0} harus diisi",
      required_if: "Data {0} harus diisi {1} memiliki isi",
      size: "Data {0} harus lebih kecil dari {1}",
      url: "Data {0} harus berupa tautan yang benar",
    },
  },
  attribute: {
    account: "Akun",
    additionalAddress: "Alamat Tambahan",
    addon: "Layanan Tambahan",
    address: "Alamat",
    addressBook: "Buku Kontak",
    addressSuggestion: "Saran Alamat",
    addressDetail: "Detail Alamat (cth. Nama Jalan)",
    addressUnit: "Unit Alamat",
    ago: "Lalu",
    airWaybill: "Air Waybill",
    all: "Semua",
    appearance: "Penampilan",
    applicationDisplay: "Penampilan Aplikasi",
    article: "Artikel",
    bankTransfer: "Transfer Bank",
    bulkOrder: "Order Borongan",
    calculator: "Kalkulator",
    cardNumber: "Nomor Kartu",
    cardPayment: "Pembayaran Kartu",
    category: "Kategori",
    checkout: "Checkout",
    city: "Kota",
    companyName: "Nama Perusahaan",
    companyIndividualName: "Name Perusahaan / Individu",
    contactInformation: "Informasi Kontak",
    country: "Negara",
    coupon: "Kupon",
    creditCard: "Kartu Kredit",
    currency: "Mata Uang",
    customer: "Customer",
    customerReferenceNumber: "Customer Reference Number",
    darkMode: "Mode Gelap",
    dashboard: "Beranda",
    dateAtt: "Tanggal {0}",
    day: "Hari",
    debitCard: "Kartu Debit",
    description: "Deskripsi",
    delivery: "Pengiriman",
    deliveryAfter: "Pengiriman Setelah",
    deliveryBefore: "Pengiriman Sebelum",
    deliveryDate: "Tanggal Pengiriman",
    deliveryPartner: "Partner Pengiriman",
    deliveryType: "Tipe Pengiriman",
    deliverySetting: "Setting Pengiriman",
    detail: "Detil",
    dimension: "Dimensi",
    district: "Kabupaten",
    driver: "Driver",
    driverTip: "Tip Driver",
    dropoff: "Lokasi Pengiriman",
    email: "Email",
    emailOrPhone: "Email atau Nomor Telepon",
    endDate: "Tanggal Akhir",
    estimation: "Estimasi",
    favorite: "Favorit",
    file: "File",
    filterOption: "Opsi Filter",
    firstName: "Nama Depan",
    fragile: "Fragile",
    goodType: "Tipe Barang",
    grossWeightPerItem: "Gross Weight per Item",
    handbook: "Buku Panduan",
    height: "Tinggi",
    helpCenter: "Pusat Bantuan",
    hour: "Jam",
    image: "Gambar",
    imageProof: "Bukti Gambar",
    instruction: "Instruksi",
    invoice: "Invoice",
    invoiceAtt: "{0} Invoice",
    item: "Barang",
    itemContent: "Isi Barang",
    itemValue: "Nilai Harga Barang",
    keyword: "Kata Kunci",
    language: "Bahasa",
    lastName: "Nama Belakang",
    lastUpdated: "Terakhir diubah",
    length: "Panjang",
    liveChat: "Live Chat",
    location: "Lokasi",
    measurementUnit: "Unit Pengukuran",
    message: "Pesan",
    minute: "Menit",
    month: "Bulan",
    name: "Nama",
    new: "Baru",
    newPassword: "Password Baru",
    nettWeightPerWeight: "Nett Weight per Item",
    note: "Catatan",
    number: "Nomor",
    notification: "Notifikasi",
    oldPassword: "Password Lama",
    optimization: "Optimisasi",
    option: "Opsi",
    optional: "Opsional",
    or: "Atau",
    order: "Pesanan",
    orderNumber: "Nomor Pesanan",
    orderStatus: "Status Pengiriman",
    package: "Paket",
    password: "Password",
    passwordConfirmation: "Konfirmasi Password",
    payment: "Pembayaran",
    paymentMethod: "Pembayaran",
    paymentOption: "Opsi Pembayaran",
    paymentTerm: "Cara Pembayaran",
    personalInfo: "Info Personal",
    phoneNumber: "Nomor Telepon",
    pickup: "Pickup",
    pickupAfter: "Pickup Setelah",
    pickupBefore: "Pickup Sebelum",
    pickupDate: "Tanggal Pickup",
    postalCode: "Kode Pos",
    postPaid: "Post Paid",
    preference: "Preferensi",
    preferredState: "Negara Pilihan",
    price: "Harga",
    priceChange: "Perubahan Harga",
    priceDetail: "Detail Harga",
    priceRate: "Tarif",
    profile: "Profil",
    progress: "Progress",
    promoCode: "Kode Promo",
    province: "Provinsi",
    purpose: "Tujuan",
    quantity: "Kuantitas",
    receipt: "Struk",
    receiver: "Penerima",
    receiverAtt: "{0} Penerima",
    remark: "Komentar",
    requestCollectionBefore: "Request Pickup Sebelum",
    requestPickupTime: "Request Waktu Pickup",
    result: "Hasil",
    roundTrip: "Round Trip",
    route: "Jalur",
    savedAddress: "Simpanan Alamat",
    savedCC: "Kartu Kredit Tersimpan",
    scheduledDate: "Tanggal Jadwal",
    scheduledOrder: "Pesanan Terjadwal",
    scheduledTime: "Waktu Jadwal",
    second: "Detik",
    sender: "Pengirim",
    senderAtt: "{0} Pengirim",
    serviceType: "Tipe Pemesanan",
    setting: "Pengaturan",
    settingResource: "Pengaturan",
    shipment: "Pengiriman",
    shipmentAtt: "{0} Pengiriman",
    signatureTitle: "Panggilan",
    signatureName: "Nama Penandatangan",
    size: "Ukuran",
    startDate: "Tanggal Awal",
    state: "Wilayah",
    step: "Langkah {0}",
    subdistrict: "Kelurahan",
    subject: "Subjek",
    summary: "Ringkasan",
    termCondition: "Syarat & Ketentuan",
    time: "Waktu",
    timeSlot: "Jadwal",
    tool: "Alat",
    topUpPackage: "Paket Top-up",
    totalPrice: "Total Harga",
    totalGrossWeight: "Berat Kotor (Gross)",
    totalNettWeight: "Berat Bersih (Netto)",
    trackingHistory: "Riwayat Pelacakan",
    transaction: "Transaksi",
    transactionType: "Tipe Transaksi",
    topUpTransferRequest: "Permintaan Transfer Top-up",
    wallet: "Wallet",
    walletTopUp: "Top-up Wallet",
    warning: "Peringatan",
    waybill: "Waybill",
    waybillLogo: "Logo Waybill",
    weight: "Berat",
    width: "Lebar",
    unit: "Unit",
    userSetting: "Pengaturan User",
    value: "Nilai",
    vehicle: "Kendaraan",
    vehicleType: "Jenis Kendaraan",
    year: "Tahun",
  },
  action: {
    accept: "Terima",
    add: "Tambah",
    addAtt: "Tambah {0}",
    apply: "Pakai",
    applyAtt: "Pakai {0}",
    applyPromoCode: "Pakai Kode Promo",
    back: "Kembali",
    calculate: "Hitung",
    calculating: "Menghitung",
    cancel: "Batal",
    change: "Ubah",
    clear: "Hapus",
    close: "Tutup",
    confirm: "Konfirmasi",
    contactUs: "Hubungi Kami",
    continue: "Lanjut",
    copy: "Salin",
    create: "Buat",
    createAtt: "Buat {0}",
    delete: "Hapus",
    download: "Download",
    downloadAtt: "Download {0}",
    downloadExcel: "Download Excel",
    downloading: "Mendownload",
    enroute: "Enroute",
    filter: "Filter",
    liveTracking: "Lacak",
    loading: "Loading",
    logout: "Logout",
    next: "Lanjut",
    optimizeAtt: "Optimisasi {0}",
    placeOrder: "Pesan",
    previous: "Kembali",
    print: "Cetak",
    printAtt: "Cetak {0}",
    rate: "Nilai",
    remove: "Hapus",
    removing: "Menghapus",
    reschedule: "Jadwal Ulang",
    reset: "Ulang",
    save: "Simpan",
    saveContact: "Simpan Kontak",
    saveExcel: "Simpan Excel",
    saving: "Menyimpan",
    searchAtt: "Cari {0}",
    searchingAtt: "Mencari {0}",
    select: "Pilih",
    send: "Kirim",
    setDefault: "Ubah Default",
    topUp: "Top Up",
    update: "Perbaru",
    updating: "Memperbarui",
    upload: "Unggah",
    uploadAtt: "Unggah {0}",
    uploading: "Mengunggah",
    uploadExcel: "Unggah Excel",
    uploadProof: "Unggah Bukti",
    verify: "Verifikasi",
  },
  general: {
    notAvailable: (ctx) => `${capitalize(ctx.named("msg"))} tidak tersedia`,
    notFound: (ctx) => `${capitalize(ctx.named("msg"))} tidak ditemukan`,
    notSelected: (ctx) => `${capitalize(ctx.named("msg"))} tidak dipilih`,
    retrieving: "Mengambil {msg}",
  },
  login: {
    welcome: "Selamat Datang",
    sendOutPackage: "Mari mulai mengirim paket menggunakan platform kami",
    enterEmail: "Masukkan Email Anda",
    enterPassword: "Masukkan Password Anda",
    signIn: "Masuk",
    or: "ATAU",
    forgotPassword: "Lupa password akun",
    changeHere: "Ubah disini",
    newToVite: "Pertama kali di " + appName,
    signUp: "Daftar sekarang",
    needHelp: "Butuh bantuan",
    clickHere: "Klik disini",
  },
  register: {
    letsStart: "Mari Mulai!",
    sendOutPackage: "Mari mulai kirim paket",
    getAccess: "Dapatkan akses ke pelayanan logistik dan platform terhandal dan tercepat untuk membantu pengiriman barang anda",
    signUp: "Daftar",
    processRegister: "Mendaftarkan akun",
    successRegisterTitle: "Berhasil registrasi akun",
    successRegisterBody: "Registrasi akun berhasil! Anda bisa mencoba untuk login akun melalui halaman login!",
    accountVerified: "Akun anda berhasil diverifikasi! Mari mulai memesan pengiriman dengan menekan {0}",
    linkHere: "link disini",
    invalidVerificationToken: "Token verifikasi tidak valid",
    chooseRegistrationMethod: "Pilih antara email atau nomor HP anda sebagai metode registrasi. Sistem kami akan mengirim kode OTP untuk diverifikasi!",
    accountExist: "Akun anda sudah terdaftar dalam sistem kami",
    directToLogin: "Silahkan login akun melalui halaman login!",
    fillUserInformationTitle: "Isi Informasi User",
    fillUserInformationInstr: "Isi informasi user anda. Anda dapat mengubah ulang data setelah melakukan login dan memasuki menu Pengaturan User.",
    countryChoice: "Pilihan negara akan menentukan jenis layanan dan mata uang yang akan Anda pakai dalam " + appName + ".",
    setupCustomerAccountTitle: "Buat Akun Pelanggan",
    setupCustomerAccountInstr: "Sebelum kita lanjut ke halaman utama, mari kita buat akun pelanggan Anda. <br/> Info pelanggan ini akan digunakan dalam setiap pembelian & pengiriman pesanan!",
    emailPurpose: "Email akan digunakan untuk menerima notifikasi dan struk pembelian / pengiriman Anda.",
  },
  forgetPassword: {
    forgetAccountPassword: "Lupa Password Akun Anda",
    sendEmail: 'Masukkan email yang terdaftar dalam sistem dan kami akan mengirimkan kode OTP untuk verifikasi',
    enterEmail: "Masukkan Email Anda",
    emailDoesntExist: "Akun email tidak valid atau terdaftar. Silahkan dicoba lagi menggunakan akun lain!",
    startRecovery: "Kirim Email Pembaruan",
    fillNewPasswordTitle: "Isi Password Baru",
    processChangingPassword: "Mengubah password baru",
    or: "ATAU",
    haveAccount: "Sudah punya akun",
    signIn: "Masuk disini",
    successChangeTitle: "Berhasil Ubah Password",
    successChangeMessage: "Password Anda telah berhasil diubah! Anda bisa mencoba login ke akun Anda dengan password baru!",
  },
  otp: {
    inputOTPCode: "Mohon masukkan kode OTP yang telah dikirim ke <b>{0}</b>!",
    verifyOTP: "Verifikasi OTP",
    notReceived: "Tidak terima kode OTP?",
    resendOTP: "Kirim Ulang Kode",
    sendingOTP: "Mengirim OTP number",
    verifyingOTP: "Memeriksa nomor OTP",
  },
  navMenuItem: {
    customer: "@:attribute.customer",
    driver: "@:attribute.driver",
    dashboard: "@:attribute.dashboard",
    createOrder: "@:action.create @:attribute.order",
    paymentOption: "@:attribute.paymentOption",
    bulkOrder: "@:attribute.bulkOrder",
    tool: "@:attribute.tool",
    settingResource: "@:attribute.settingResource",
    helpCenter: "@:attribute.helpCenter",
    account: "@:attribute.account",
    userSetting: "@:attribute.userSetting",
    contactUs: "@:action.contactUs",
  },
  dashboard: {
    overview: "Ringkasan",
    orderList: "Daftar Pesanan",
    summary: "Rekap",
    convenientDelivery: "Pilih pengiriman \n ternyaman",
    createOrder: "Tambah paket",
    filterPickupDate: "Filter Tanggal Pickup",
    myParcel: "Paket Saya",
    clickDetail: "Klik untuk lebih detail",
    noDriver: "Agen pengiriman belum ditugaskan",
    noOrder: "Pesanan tidak ditemukan",
    downloadStatement: "Klik tombol download untuk menyimpan laporan berisi pesanan yang telah diselesaikan dalam bentuk PDF",
    totalOrder: "Jumlah Pesanan",
    filterKeywordCaption: "Nomor pesanan, informasi pickup dan pengiriman, status, agen pengiriman, tipe pesanan",
  },
  shippingDetail: {
    shippingDetail: "Detail Pengiriman",
    clickOrder: "Klik salah satu pesanan untuk lihat detail pengiriman",
    thankYouRating: "Terima kasih atas penilaiannya",
    pickupBefore: "Pickup sebelum",
    pickupAt: "Pickup pada",
    pickupAfter: "Pickup setelah",
    estimatedPickupBefore: "Estimasi pickup sebelum",
    contactQuery: "Jika ada kendala atau pertanyaan mengenai pengiriman paket, silahkan merujuk ke pusat bantuan atau kirim email via support@viamove.co",
    requestCollectionBefore: "Request pickup sebelum",
    estimatedDeliveryBefore: "Estimasi pengiriman sebelum",
    estimatedDeliveryAt: "Estimated pengiriman pada",
    notAvailable: "Tidak tersedia",
    packageNotAvailable: "@.capitalize:(attribute.package) tidak tersedia",
    driverDetail: "Detail Agen Pengiriman",
    rateOrder: "Nilai Pesanan",
    rateYourOrder: "Nilai Pesanan Anda",
    selectStar: "Pilih tanda bintang untuk memberi penilaian",
    selectPaperSize: "Pilih Ukuran Kertas",
    enrouteOrder: "Enroute Pengiriman",
    enrouteConfirmation: "Pesanan akan diubah statusnya menjadi enroute. Pastikan agen pengiriman sudah mengambil paket dan sedang dalam perjalanan ke lokasi pengiriman",
    cancelOrder: "Batal Pesanan",
    cancelOrderAction: "Batal Pesanan | Batal {count} Pesanan",
    viewRemainingOrder: "Lihat sisa pesanan",
    cancelStatement: {
      confirmation: "Pesanan ini akan dibatalkan",
      refund: "Jika dibatalkan, pembayaran untuk pesanan ini akan dikembalikan sebanyak {0}",
      continue: "Apakah anda ingin melanjutkan pembatalan?",
      remainingOrder: "Pengembalian dana tidak berlaku kecuali {baseCount} pesanan awal juga dibatalkan.<br/> Sisa pesanan awal(s): {remaining}",
      noRefund: "Pengembalian dana tidak berlaku untuk pesanan ini",
    },
  },
  setting: {
    accountInformation: "Informasi akun",
    accountInformationCaption: "Anda dapat mengubah informasi dan settingan akun dalam halaman ini",
    emailChangeWarning: "System akan mengirim email verifikasi apabila alamat email diubah. Harap diverifikasikan akunnya untuk dapat masuk kembali",
    companyNameOptional: "Masukkan N/A apabila tidak ada nama perusahaan",
    changeCountryService: "Ubah pilihan negara",
    countryServiceCaption: "Buat pesanan sesuai dengan layanan yang tersedia dalam negara yang dipilih",
    changePassword: "Ubah password",
    changePasswordCaption: "Ubah password untuk menjaga keamanan akun anda",
    endSession: "Akhiri Sesi",
    logoutCaption: "Jika ingin mengakhiri sesi, anda akan logout dari aplikasi dan perlu melakukan login ulang untuk lanjut",
    stylingCaption: "Atur penampilan sesuai preferensi anda",
    addressBookCaption: "@.capitalize:(attribute.addressBook) menyimpan informasi kontak anda dan dapat dipilih ketika membuat pesanan",
    waybillCaption: "Atur format @:(attribute.waybill) sesuai keperluan anda",
    addLogoWaybill: "Tambahkan logo di bagian atas kiri @:(attribute.waybill)",
    displayLogo: "Tampilan logo",
    uploadNewLogo: "Upload logo baru",
    selectImageFile: "Klik disini untuk memilih file gambar",
    sendSMSEnroute: "Kirim SMS ke penerima ketika pengiriman telah dikoleksi oleh agen pengiriman",
    hideSenderDetail: "Sembunyikan informasi pengirim dalam @:(attribute.waybill) dan halaman pelacakan (Hanya berlaku untuk Same Day dan Next Day Premium)",
    inputNewEmailInstr: "Silahkan masukkan email baru dan sistem kami akan mengirim kode OTP untuk verifikasi!",
    inputNewPhoneNumberInstr: "Silahkan masukkan nomor telepon baru dan sistem kami akan mengirim kode OTP untuk verifikasi!",
    useOrderReference: "Aktifkan pengambilan pesanan oleh agen menggunakan nomor referensi yang dimasukan ketika membuat pesanan",
    linkedProvider: "Akun Terhubung",
    linkedProviderCaption: "Akun tautan yang terhubung dengan akun untuk proses login",
    unlinkConfirmation: "Setelah logout, Anda harus mengubah password jika akun didaftar menggunakan akun tautan. Apakah anda ingin lanjut?"
  },
  addressBook: {
    searchAddress: "Cari alamat sesuai kata kunci (kode pos, kabupaten, kelurahan)",
    findAddressBook: "Cari @:(attribute.addressBook)",
    searching: "Sedang mencari '{0}'",
    suggestionShown: "{0} alamat ditemukan",
    checkLocation: "Memeriksa validasi lokasi",
    postalCodeAutoGenerate: "Kode pos otomatis diisi dari saran alamat",
    checkingLocation: "Memeriksa lokasi",
    invalidContactPostalCode: "Postal code tidak sah. Silahkan hapus dan bikin kontak baru",
    removeConfirmation: "Informasi kontak ini akan dihapus. Apakah anda ingin lanjut?",
  },
  paymentMethod: {
    noSavedCard: "Akun ini tidak ada simpanan kartu kredit",
    topUpInstr: "Pilih salah satu paket top up dibawah ini",
    noTopUpPackage: "Top-up package belum tersedia. Silahkan contact support untuk informasi lebih lanjut",
    topUpSelectRequired: "Mohon pilih salah satu paket top-up diatas",
    paymentMethodInstr: "Pilih salah satu metode pembayaran dibawah ini",
    proofOfTransferRequired: "Mohon diunggah file gambar bukti pembayaran anda",
    addNewCard: "Tambah kartu baru",
    addNewCardInstr: "Masukkan nomor detail kartu anda dibawah ini",
    uploadProofInstr: "Klik disini untuk mengunggah bukti transfer",
    orInputCardNumber: "Atau masukkan nomor kartu",
    setCardDefaultConfirmation: "Kartu yang dipilih akan dijadikan sebagai kartu preferensi anda. Apakah anda ingin lanjut?",
    oneTwoWorkingDays: "1 - 2 hari kerja",
    immediate: "Langsung",
    topUpAmountRequired: "Mohon masukkan nominal top up",
    customTopUpAmountInstr: "atau masukkan nominal top up Anda di sini.",
    confirmTopUp: "Konfirmasi TOP-UP",
    confirmTopUpInstr: "Mohon pastikan data sudah sesuai sebelum submit.",
    topupAmountAvailability: "Kustom nominal hanya tersedia untuk pembayaran kartu.",
  },
  paymentTransaction: {
    transactionCaption: "Semua transaksi pembayaran anda dapat ditampilkan dalam daftar ini. Klik ikon download untuk melihat struk transaksi yang dipilih",
  },
  coupon: {
    transactionCaption:
      "Kupon dapat diterima setelah membeli top-up wallet dengan harga tertentu. Kupon dapat dipakai sebagai diskon dalam pemesanan. Harap diperhatikan bahwa hanya satu (1) kupon atau kode promo dapat dipakai dalam satu pemesanan",
    available: "Kupon tersedia",
    used: "Kupon terpakai",
    expired: "Kupon kadaluarsa",
    offAmount: "Potongan {0}",
    anyOrder: "Semua nomor pesanan",
    expiredAt: "Berakhir pada",
  },
  topUpTransferRequest: {
    transactionCaption:
      'Top-up wallet yang dibayar menggunakan method "@:(action.uploadProof)" akan ditampilkan dalam daftar ini! Anda bisa mengecek apabila permintaan telah disetujui oleh tim kami. Apabila transaksi tidak disetujui, silahkan membuat ulang permintaan transfer top-up baru',
  },
  createOrder: {
    noDeliveryType: "Tipe pemesanan tidak tersedia di negara pilihan",
    oneToThreeDaysConfirmation: "1 - 3 Days Delivery adalah layanan yang {notGuaranteed}. Dengan $8, anda bisa memilih layanan Next Day Delivery (Premium) yang lebih terjamin. Apakah anda ingin lanjut?",
    notGuaranteed: "tidak terjamin",
    understandRisk: "Saya mengerti resikonya",
    termConditionCaption: "Dengan menggunakan layanan kami, Anda menyetujui persyaratan dibawah ini. Mohon dibaca dengan seksama sebelum melanjutkan",
    acceptTermCondition: "Saya telah membaca dan menyetujui syarat dan ketentuan ini",
    uploadExcelInstr: "Klik untuk mencari atau letakkan file excel disini",
    validateCheckoutHeader: "Periksa data anda sebelum pesan",
    validateCheckoutInstr: "Periksa semua kelengkapan paket beserta informasi pengirim dan penerima sebelum melakukan pesanan",
    packagingInstr:
      "Kemaskan paket dengan bahan yang tepat untuk memastikan jaminan pengiriman anda sampai dengan aman dan utuh. Pastikan juga tidak ada banyak ruang kosong dalam paket untuk menghindari goncangan yang dapat merusak kotak dan isi dalamnya",
    paymentMethodInstr: "Pilihlah salah satu metode pembayaran yang tersedia",
    promoCodeInquiry: "Apakah punya kode promo?",
    singlePromoCode: "Harap diperhatikan hanya satu kode promo yang boleh dipakai dalam tiap pemesanan",
    selectTypeSize: "Pilih tipe dan ukuran paket",
    selectTimeSlot: "Pilih jadwal tersedia",
    selectLocation: "Pilih lokasi",
    selectLocationAndPackage: "Pilih lokasi dan tentukan paket",
    selectServiceType: "Pilih tipe pemesanan",
    selectVehicleType: "Pilih tipe kendaraan",
    selectPackageCurrency: "Pilih nilai mata uang paket",
    selectPricingRate: "Pilih tarif yang tersedia",
    selectRoundTripPackage: "Pilih tipe dan ukuran paket round trip",
    timeSlotInstr: "Pilih tipe pemesanan dan jadwal yang tersedia",
    serviceChangeDateInstr: "Apabila tidak ada tipe pemesanan dan jadwal yang muncul, mohon diubah tanggal pickup ke tanggal selanjutnya",
    rateChangeDateInstr: "Apabila tidak ada tarif yang muncul, mohon diubah tanggal pickup ke tanggal selanjutnya",
    addonAvailable: "Beberapa tipe pemesanan juga tersedia dengan tambahan (addon) yang dapat anda sertakan dalam pemesanan",
    noServiceType: "Tidak ada tipe pemesanan yang tersedia. Mohon diubah ke tanggal pickup lainnya",
    noPriceRate: "Tidak ada tarif yang tersedia. Mohon diubah ke tanggal pickup lainnya",
    checkingDateAvailability: "Memeriksa ketersediaan tanggal",
    locationInstr: "Pilih lokasi pickup dan pengiriman dari daftar alamat yang disarankan. Anda akan diminta untuk mengisi informasi kontak",
    contactInfoInstr: "Kami sarankan untuk mengisi nomor telepon yang dapat menerima SMS apabila ada terjadi pengiriman gagal",
    specialRequirement: "Mohon diperhatikan bahwa persyaratan khusus hanya akan dipatuhi berdasarkan kemampuan kami",
    pinnedLocationInstr: "Mohon diperhatikan bahwa sistem akan memproses perhitungan tarif berdasarkan lokasi yang dipilih",
    checkoutPlaceOrder: "Checkout dan pesan",
    notesDriver: "Catatan untuk agen pengiriman",
    printParcelWaybill: "Mohon CETAK kertas waybill dan tempelkan pada paket yang akan dikirim",
    writeOrderNumber: "Anda juga dapat menulis nomor pesanan di kotak paketnya",
    printInvoiceWaybill: "Mohon CETAK 2x invoices, air waybill dan tempelkan pada paket yang akan dikirim",
    successCreate: "Pesanan berhasil diproses",
    selectFromSuggestion: "Pilih dari daftar",
    guaranteedAcceptance: "Penerimaan terjamin",
    noMinimumOrder: "Tidak ada minimal order",
    availableDayRange: "Tersedia dari {0} sampai {1}",
    noExcessiveCredit: "Tidak perlu top-up kredit ekstra",
    available24hour: "Tersedia 24/7",
    wideSelectionVehicle: "Berbagai pilihan kendaraan",
    distanceBasedRate: "Tarif berdasarkan jarak",
    multipleDropoff: "Berbagai titik pengiriman",
    pickupMinuteAfterAcceptance: "Pickup dalam {0} menit setelah pesanan diterima, pengiriman dalam {1} menit (per titik pengiriman)",
    minimumOrderCreated: "Minimum {0} pemesanan per transaksi",
    noGuaranteedDelivery: "Pengiriman tidak terjamin",
    questionInquiry: "Ada pertanyaan?",
    vehicleFitParcel: "Pastikan anda memilih tipe kendaraan yang dapat menampung paket anda",
    inputSuggestionInstr: "Anda akan diminta untuk memilih dari daftar tiap pengisian untuk dapat lanjut ke tahap selanjutnya",
    assistPostalNotFound: "Apabila kota atau kode pos tidak dapat ditemukan, mohon hubungi kami melalui live chat untuk bantuan",
    documentShipmentDesc: "Dokumen termasuk legal, finansial, ataupun dokument bisnis. Barang yang bernilai tinggi TIDAK dianggap sebagai pengiriman dokumen",
    nonDocumentShipmentDesc: "Non dokumen meliputi are barang dagangan atau komoditas untuk kepentingan personal maupun ataupun komersial ( Perlu invoice )",
    sendEmailAirWaybill: "Sistem akan mengirim email yang terlampir dengan air waybil atau invoice kepada sender setelah pesanan dibuat",
    describeUniqueItem: "Deskripsikan tiap barang secara individual",
    dateBasedRate: "Sistem akan menampilkan tarif berdasarkan tanggal dan kebutuhan yang telah anda pilih",
    rateNotIncludeTax: "Tarif yang ditampilkan tidak termasuk harga bea dan pajak",
    printRequired: "Anda akan diminta untuk mencetak {0}",
    generateInvoiceInstr: "Apabila anda tidak memiliki invoice, sistem kami dapat menghasilkan invoice melalui {0} dan masukkan data yang diperlukan",
    invoiceGenerateAfterCreate: "Invoice akan dibikin setelah pemesanan telah selesai",
    customInvoiceRequired: "Anda akan memerlukan invoice untuk melakukan pengiriman ini",
    useOwnInvoice: "Pakai Invoice Sendiri",
    uploadBulkExcel: "Menghitung data excel. Ini mungkin memerlukan beberapa saat",
    checkoutBulk: "Memproses pesanan anda. Ini mungkin memerlukan beberapa saat",
  },
  reschedule: {
    confirmReschedule: "Konfirmasi Perubahan Jadwal",
    validateRescheduleInstr: "Mohon diperiksa dan konfirmasi jadwal yang telah Anda pilih sebelum melakukan perubahan jadwal",
  },
  tool: {
    calculateRate: "Hitung Tarif",
    apiIntegration: "Integrasi API",
    connectWithUs: "Connect with us",
    rateInstr: "Lihatlah perincian jenis pengiriman, area terbatas, dan tarifnya melalui {0}",
    handbookInstr: "Pelajari lebih lanjut mengenai website dan fitur Viamove yang mungkin anda bisa manfaatkan melalui {0}",
    linkRightHere: "link disini",
    apiInstr: "Viamove dapat memberikan layanan API yang dapat mengintegrasikan pelayanan kami dengan alur kerja bisnis anda",
    apiAutomateFlow: "Viamove menyediakan kumpulan endpoint yang ringan, cepat, dan fleksibel. Memberikan kemampuan untuk mengotomatisasi kepentingan logistik anda menjadi lebih mudah dan cepat",
    apiContact: "Klik {0} untuk hubungi kami apabila ada pertanyaan lebih lanjut",
  },
  notification: {
    viewAll: "Lihat semua notifikasi",
  },
  helpCenter: {
    groupDesc: "Jika anda mencari info tentang {0}, klik disini untuk menampilkan topik yang dapat menjawab pertanyaan anda",
    clickLiveChat: "Klik disini untuk memulai live chat dengan kami",
    howCanWeHelp: "Hello, ada yang bisa kami bantu?",
    useKeywordArticle: "Masukkan kata kunci untuk mencari artikel yang berhubungan",
    notAnswer: "Bukan jawaban yang anda cari?",
  },
  driver:{
    downloadInstr: "Silahkan download aplikasi " + appName + " dan daftarkan diri untuk menjadi agen pengiriman Viamove!"
  }
};

export default message;
